/**
 * Simulation : Donne une mensualité selon un montant d'emprunt, une durée et un taux
 * @param {number} k Montant total à emprunter
 * @param {number} t Taux
 * @param {number} n Durée en année
 */
export function monthlyCalc(k, t, n) {
  n = n * 12
  const m = k*(t/100)/(1-Math.pow((1+t/100/12),(-n)))/12
  return Math.round(m)
}

/**
 * Simulation : Donne un montant d'emprunt selon une mensualité, une durée et un taux
 * @param {number} m Mensualité à rembourser
 * @param {number} t Taux
 * @param {number} n Durée en année
 */
export function amountCalc(m, t, n) {
  n = n * 12
  const k = m*(1-(Math.pow((1+t/100/12),(-n))))/(t/100/12)
  return Math.round(k)
}

/**
 * Affiche une barre de progression
 * @param {string} c Container selector
 * @param {boolean} i = true Affiche (true) ou désaffiche la barre de progression (false)
 * @param {number} p = 0 Pourcentage de progression
 */
export function displayProgress(c, i = true, p = 0) {
  if ( i )
    $(c).find('.progress').show()
  else
    $(c).find('.progress').hide()
  $(c).find('.progress .progress-bar').css('width', p + '%').attr('aria-valuenow', p).html(p + '% terminé')
}

/**
 * Scroll vers un sélecteur en jquery
 */
export function scroll(c) {
  $('html, body').animate({
    scrollTop: ($(c).offset().top - 90) - -1
  }, 500)
}
